package it.neckar.lizergy.comments.client

import it.neckar.lizergy.comments.model.CommentsForComponent
import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed interface FetchCommentsForComponentResponse : RestResponse<CommentsForComponent> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: CommentsForComponent) : FetchCommentsForComponentResponse, RestResponse.GoodResponse<CommentsForComponent>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchCommentsForComponentResponse, RestResponse.BadResponse<CommentsForComponent>

  companion object {
    fun good(data: CommentsForComponent): FetchCommentsForComponentResponse = Good(data)

    fun bad(): FetchCommentsForComponentResponse = Failed

    fun createFor(data: CommentsForComponent?): FetchCommentsForComponentResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}
